import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerLibriSocialiModalComponent } from './worker-libri-sociali-modal';


export const WorkerLibriSocialiModalModule: string = ng
    .module('worker-libri-sociali-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerLibriSocialiModalComponent', WorkerLibriSocialiModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-libri-sociali-modal/worker-libri-sociali-modal.module.ts